import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Constants } from '@app/common/constants';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CultureService {

  private getLcidForCurrentLocale$: Observable<number>;
  private getRegionCodeForCurrentLocale$: Observable<string>;

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private localeId: string) {
  }

  getLcidForCurrentLocale(): Observable<number> {
    if (this.getLcidForCurrentLocale$) {
      return this.getLcidForCurrentLocale$;
    }

    const httpParams = new HttpParams().append('languageCode', this.getLocaleWithSuffix(false));
    this.getLcidForCurrentLocale$ = this.http.get<number>(`${Constants.API_ENDPOINT}/culture`, { params: httpParams })
      .pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );

    return this.getLcidForCurrentLocale$;
  }

  getRegionCodeForCurrentLocale(): Observable<string> {
    if (this.getRegionCodeForCurrentLocale$) {
      return this.getRegionCodeForCurrentLocale$;
    }
    const httpParams = new HttpParams().append('languageCode', this.getLocaleWithSuffix(false));
    this.getRegionCodeForCurrentLocale$ = this.http.get(`${Constants.API_ENDPOINT}/culture/region`, { params: httpParams, responseType: 'text' })
      .pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );

    return this.getRegionCodeForCurrentLocale$;
  }

  /**
   * Gets the full locale in format en-us, sv-se etc.
   * @param useSpTranslationFormat
   * Because sharepoint only supports one variant of norwegian (nb-no)
   * we rewrite nn-no to nb-no when fetching pages from sharepoint.
   */
  getLocaleWithSuffix(useSpTranslationFormat = true): string {
    let localIdWithSuffix = this.localeId;
    if (localIdWithSuffix?.length === 2) {
      if (localIdWithSuffix === 'en') {
        localIdWithSuffix = `${localIdWithSuffix}-us`;
      } else if (localIdWithSuffix === 'sv') {
        localIdWithSuffix = `${localIdWithSuffix}-se`;
      } else if (localIdWithSuffix === 'da') {
        localIdWithSuffix = `${localIdWithSuffix}-dk`;
      } else if (localIdWithSuffix === 'fi') {
        localIdWithSuffix = `${localIdWithSuffix}-fi`;
      } else if (localIdWithSuffix === 'nb') {
        localIdWithSuffix = `${localIdWithSuffix}-no`;
      } else if (localIdWithSuffix === 'nn') {
        if (useSpTranslationFormat) {
          localIdWithSuffix = `nb-no`;
        } else {
          localIdWithSuffix = `${localIdWithSuffix}-no`;
        }
      } else if (localIdWithSuffix === 'no') {
        localIdWithSuffix = `nb-no`;
      }
    }
    return localIdWithSuffix;
  }
}
